import { ButtonHTMLAttributes, FC } from 'react';
import { useFormContext } from '@new/common/hooks/form';
import { Button } from '../Button/Button';

export interface SubmitButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  label: string;
}

export const SubmitButton: FC<SubmitButtonProps> = ({ label, ...rest }) => {
  const form = useFormContext();
  return (
    <form.Subscribe
      selector={(state) => {
        return {
          isSubmitting: state.isSubmitting,
          canSubmit: state.canSubmit && state.isDirty,
        };
      }}
    >
      {({ isSubmitting, canSubmit }) => {
        const isDisabled = !canSubmit || isSubmitting;
        return (
          <Button {...rest} disabled={isDisabled} variant="primary">
            {isSubmitting ? 'Submitting...' : label}
          </Button>
        );
      }}
    </form.Subscribe>
  );
};
